export default __webpack_public_path__ + "static/media/advan-bg.57287316.svg";